const DROPDOWN_INJECTION_KEY = Symbol("elDropdown");
const DROPDOWN_INSTANCE_INJECTION_KEY = "elDropdown";

export { DROPDOWN_INJECTION_KEY, DROPDOWN_INSTANCE_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
